import { Days } from "./types/types";

export const defaultDays: Days = {
  monday: {
    openingHour: 10,
    closingHour: 20,
    isOpen: true
  },
  tuesday: {
    openingHour: 10,
    closingHour: 20,
    isOpen: true
  },
  wednesday: {
    openingHour: 10,
    closingHour: 20,
    isOpen: true
  },
  thursday: {
    openingHour: 10,
    closingHour: 20,
    isOpen: true
  },
  friday: {
    openingHour: 10,
    closingHour: 20,
    isOpen: true
  },
  saturday: {
    openingHour: 10,
    closingHour: 20,
    isOpen: true
  },
  sunday: {
    openingHour: 10,
    closingHour: 20,
    isOpen: true
  }
}